import { Component } from '@angular/core';
import type { ContactListSettings, ContactListTranslationKeys } from '../../../interfaces/Widget.interface';
import { WidgetSize } from '../../../providers/widgets.contants';
import { ListOfContactsComponent } from '../../list-of-contacts/list-of-contacts';
import { AbstractWidgetClass } from '../AbstractWidget.class';
import { WidgetCardComponent } from '../widget-card/widget-card';

@Component({
    styleUrls: ['./widget-contact-list.scss'],
    selector: 'widget-contact-list',
    templateUrl: 'widget-contact-list.html',
    imports: [WidgetCardComponent, ListOfContactsComponent]
})
export class WidgetContactListComponent extends AbstractWidgetClass<ContactListTranslationKeys, ContactListSettings> {
    size = WidgetSize.HALF;
}
